import { render, staticRenderFns } from "./SupportMessageListItem.vue?vue&type=template&id=7b9eb1ec&scoped=true&"
import script from "./SupportMessageListItem.vue?vue&type=script&lang=js&"
export * from "./SupportMessageListItem.vue?vue&type=script&lang=js&"
import style0 from "./SupportMessageListItem.vue?vue&type=style&index=0&id=7b9eb1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9eb1ec",
  null
  
)

export default component.exports